import { AdmissionsAPI } from './admissionsAPI';

const postgraduateAPI = new AdmissionsAPI(undefined, {
  portal: 'postgraduate',
  category: 'postgraduate',
});

export default postgraduateAPI;
